import { FC } from "react";
import RequestDemoFormSteps from "./RequestDemoFormSteps";
import RequestDemoModalContainer from "./RequestDemoModalContainer";

type RequestDemoModalProps = {
  onClose: () => void;
}

const RequestDemoModal: FC<RequestDemoModalProps> = ({ onClose }) => {
  return (
    <RequestDemoModalContainer onClose={onClose}>
      <RequestDemoFormSteps onClose={onClose} />
    </RequestDemoModalContainer>
  );
};

export default RequestDemoModal;
